<div class="dsac" [class.is-disabled]="disabled">
	<label *ngIf="label" class="dsac-label">
		{{ label }}<span *ngIf="required" class="dsac-req">*</span>
	</label>
	<div class="dsac-box" [class.is-open]="isOpen" cdkOverlayOrigin #origin="cdkOverlayOrigin">
		<span class="dsac-ic">
			<ng-container *ngIf="prefixTpl; else lupa">
				<ng-container *ngTemplateOutlet="prefixTpl"></ng-container>
			</ng-container>
			<ng-template #lupa><mat-icon>search</mat-icon></ng-template>
		</span>
		<input
			#input
			type="text"
			class="dsac-input"
			role="combobox"
			autocomplete="off"
			[attr.aria-expanded]="isOpen"
			[placeholder]="placeholder"
			[disabled]="disabled"
			[value]="text"
			(input)="onInput($event)"
			(focus)="open()"
			(blur)="onBlur()"
			(keydown)="onKeydown($event)"
		/>
		<span *ngIf="loading" class="dsac-spin" aria-hidden="true"></span>
		<button
			*ngIf="text && !disabled && !loading"
			type="button"
			class="dsac-clear"
			[attr.aria-label]="'Limpiar selección'"
			(mousedown)="$event.preventDefault()"
			(click)="clear()"
		>
			<mat-icon>close</mat-icon>
		</button>
		<span *ngIf="suffixTpl" class="dsac-suffix">
			<ng-container *ngTemplateOutlet="suffixTpl"></ng-container>
		</span>
	</div>
	<small *ngIf="hint" class="dsac-hint">{{ hint }}</small>
</div>

<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="origin"
	[cdkConnectedOverlayOpen]="isOpen"
	[cdkConnectedOverlayWidth]="panelWidth"
	[cdkConnectedOverlayViewportMargin]="8"
	(overlayOutsideClick)="onOutsideClick()"
	(detach)="close()"
>
	<div class="dsac-panel" role="listbox">
		<div *ngIf="loading" class="dsac-empty">{{ loadingText }}</div>
		<div
			*ngFor="let option of filtered; index as i"
			class="dsac-opt"
			role="option"
			[class.active]="i === activeIndex"
			[attr.aria-selected]="i === activeIndex"
			(mouseenter)="activeIndex = i"
			(mousedown)="$event.preventDefault(); select(option)"
		>
			<ng-container
				*ngTemplateOutlet="optionTpl || defaultOptTpl; context: { $implicit: option }"
			></ng-container>
		</div>
		<div *ngIf="!loading && !filtered.length" class="dsac-empty">{{ noResults }}</div>
		<div *ngIf="moreText && totalMatches > filtered.length" class="dsac-more">
			{{ moreText(filtered.length, totalMatches) }}
		</div>
	</div>
</ng-template>

<ng-template #defaultOptTpl let-option>{{ displayWith(option) }}</ng-template>
